import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {environment} from '@env/environment';
import {canShowCallAgentNavigation} from 'app/navigation/nahaus.navigation';
import {AuthService} from '@shared/services/auth.service';
import {filter, map, take} from 'rxjs/operators';

/**
 * Guards the /Telefon-Agent route the same way the menu item is gated:
 *  - Dev: everyone,
 *  - Beta: only allowlisted customers (see callAgentBetaCustomerIDs),
 *  - Production: nobody.
 * Prevents a non-allowlisted beta user from reaching the feature via direct URL.
 */
export const canAccessCallAgentGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (!environment.production) {
        return true;
    }

    if (canShowCallAgentNavigation(authService.customerID)) {
        return true;
    }

    return authService.customerID$.pipe(
        filter((customerID) => !!customerID),
        take(1),
        map((customerID) => canShowCallAgentNavigation(customerID)
            ? true
            : router.createUrlTree(['fehler', '403'], {
                queryParams: {permission: 'CALL_AGENT_BETA'},
            }))
    );
};
